var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('earth-layout',[_c('template',{slot:"A"},[_c('u-header',{attrs:{"title":_vm.$t('_.object_settings', { object: _vm.$t('_.tax') }),"has-brand-switcher":true}}),_vm._v(" "),_c('brand-tax-settings')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }